module.exports = __webpack_public_path__ + "493b620382e33d5520ad75b9eadf146b.svg";